import { render, staticRenderFns } from "./PhotoFilter.vue?vue&type=template&id=4b6e45c6"
import script from "./PhotoFilter.vue?vue&type=script&lang=js"
export * from "./PhotoFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports